import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SelectedProduct } from './products';
import { StorageService } from './storage';

@Injectable({
  providedIn: 'root'
})
export class CartService {
  private readonly DB_NAME = 'ShopDB';
  private readonly STORE_NAME = 'CartStore';
  private cart$ = new BehaviorSubject<SelectedProduct[]>([]);

  constructor(private indexedDb: StorageService<SelectedProduct>) {
    this.init();
  }

  private async init(): Promise<void> {
    const existingCart = await this.indexedDb.getAll(this.DB_NAME, this.STORE_NAME);
    this.cart$.next(existingCart);
  }

  get cartChanges$() {
    return this.cart$.asObservable();
  }

  async updateCart(products: SelectedProduct[]): Promise<void> {
    await this.indexedDb.putAll(this.DB_NAME, this.STORE_NAME, products);
    this.cart$.next(products);
  }

  async clearCart(): Promise<void> {
    await this.updateCart([]);
  }
}
